import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-47b84144"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex justify-between border-b py-1 px-3 text-xs h-14 items-center" };
const _hoisted_2 = { class: "flex gap-2 items-center" };
const _hoisted_3 = { class: "flex items-center" };
import { AlertTriangleIcon, CheckCircleIcon, InfoCircleIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { UISpin, UITextSmMedium, UITooltip } from '@gohighlevel/ghl-ui';
import { truncate } from 'lodash';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ProcessingQueueItem',
    props: {
        file: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(UITooltip), null, {
                    trigger: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_unref(UITextSmMedium), { class: "max-w-sm truncate text-black" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(truncate)(_ctx.file.name, { length: 35 })), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ])
                    ]),
                    default: _withCtx(() => [
                        _createVNode(_unref(UITextSmMedium), { class: "max-w-sm truncate text-white" }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.file.name), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                _createElementVNode("div", _hoisted_3, [
                    (!_ctx.file.processed)
                        ? (_openBlock(), _createBlock(_unref(UISpin), {
                            key: 0,
                            size: 14
                        }))
                        : (_ctx.file.status === 'success')
                            ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                                key: 1,
                                class: "w-4 h-4 text-apple-500"
                            }))
                            : _createCommentVNode("v-if", true),
                    (_ctx.file.status === 'failed' || _ctx.file.status === 'warning')
                        ? (_openBlock(), _createBlock(_unref(UITooltip), {
                            key: 2,
                            class: ""
                        }, {
                            trigger: _withCtx(() => [
                                (_ctx.file.status === 'failed')
                                    ? (_openBlock(), _createBlock(_unref(InfoCircleIcon), {
                                        key: 0,
                                        class: "w-5 h-5 stroke-red-500"
                                    }))
                                    : _createCommentVNode("v-if", true),
                                (_ctx.file.status === 'warning')
                                    ? (_openBlock(), _createBlock(_unref(AlertTriangleIcon), {
                                        key: 1,
                                        class: "w-5 h-5 stroke-orange-500"
                                    }))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            default: _withCtx(() => [
                                _createVNode(_unref(UITextSmMedium), { class: "max-w-sm truncate text-white" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.file.status === 'failed'
                                            ? _ctx.$t('common.downloadFailed')
                                            : _ctx.$t('common.downloadFileSizeExceeded')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }))
                        : _createCommentVNode("v-if", true)
                ])
            ]));
        };
    }
});
